import { openDB } from "idb";
import { uiAlert } from "../components/alerts/customAlert/uiAlert";

// ✅ Initialize or get DB
export const createIDB = async (storeName) => {
  try {
    let db = await openDB("StorelenseOfflineDB");
    // 🔹 auto-close if a newer version is requested elsewhere
    db.onversionchange = () => {
      console.warn("[IDB] versionchange - closing connection");
      db.close();
    };
    if (!db.objectStoreNames.contains(storeName)) {
      const newVersion = db.version + 1;
      db.close();
      db = await openDB("StorelenseOfflineDB", newVersion, {
        upgrade(upgradeDB) {
          if (!upgradeDB.objectStoreNames.contains(storeName)) {
            upgradeDB.createObjectStore(storeName);
            console.log(`✅ Object store "${storeName}" created`);
          }
          if (!upgradeDB.objectStoreNames.contains("offlineQueue")) {
            upgradeDB.createObjectStore("offlineQueue", { keyPath: "id", autoIncrement: true });
            console.log(`✅ Object store "offlineQueue" created`);
          }
        },
      });
    }
    return db;
  } catch (error) {
    console.log(error);
  }
};

// ✅ Save Data
export const saveData = async (objectName, data) => {
  try {
    const db = await createIDB(objectName);
    const tx = db.transaction(objectName, "readwrite");
    const store = tx.objectStore(objectName);
    const key = await store.put(data, objectName);
    let state = await tx.done;

    console.log(`✅ Data saved to "${objectName}"`);

    return key;
  } catch (error) {
    console.log(error);
  }
};

// ✅ Get Data
export const getAllData = async (objectName) => {
  try {
    if (!objectName) {
      throw new Error("getAllData: objectName (key) is missing");
    }

    const db = await createIDB(objectName);
    const tx = db.transaction(objectName, "readonly");
    const store = tx.objectStore(objectName);
    const data = await store.get(objectName);
    return data;
  } catch (error) {
    console.log(error);
  }
};

// ✅ Modify Data array
export const modifyTansactionData = async (objectName, data, key) => {
  try {
    const db = await createIDB(objectName);
    const tx = db.transaction(objectName, "readwrite");
    const store = tx.objectStore(objectName);
    console.log(store);

    /* get current array */
    let currentData = await store.get(objectName);

    if (currentData) {
      console.log(currentData.todayTransactions.todaysTransactions);

      if (currentData.todayTransactions.todaysTransactions.length === 0) {
        currentData.todayTransactions.todaysTransactions = [data];

        let { UpdatedStoreProductCollection, productsAppraochingStockLimitNames, shouldSendNotification } = updateStoreProductCollectionsFunc(
          currentData,
          data,
        );

        currentData.storeProductCollection = UpdatedStoreProductCollection;

        await store.put(currentData, objectName);
        await tx.done;
        console.log(`✅ Data modified in "${objectName}"`);
        console.log(currentData);
        return { UpdatedStoreProductCollection, productsAppraochingStockLimitNames, shouldSendNotification };
      } else {
        let newArray = [...currentData.todayTransactions.todaysTransactions, data];
        currentData.todayTransactions.todaysTransactions = newArray;

        let { UpdatedStoreProductCollection, productsAppraochingStockLimitNames, shouldSendNotification } = updateStoreProductCollectionsFunc(
          currentData,
          data,
        );

        currentData.storeProductCollection = UpdatedStoreProductCollection;

        await store.put(currentData, objectName);
        await tx.done;
        console.log(`✅ Data modified in "${objectName}"`);

        return { UpdatedStoreProductCollection, productsAppraochingStockLimitNames, shouldSendNotification, error: null };
      }
    }
  } catch (error) {
    console.log(error);
    return { UpdatedStoreProductCollection: null, productsAppraochingStockLimitNames: null, shouldSendNotification: null, error: error.message };
  }
};

// ✅ return all product as it should be handled in the server
/* transID is generate in the client and will be used for test and then transactionID = _id will be removed */
export const returnAllProductsInTodayTransaction = async (objectName, transactionID) => {
  const db = await createIDB(objectName);
  const tx = db.transaction(objectName, "readwrite");
  const store = tx.objectStore(objectName);
  let currentData = await store.get(objectName);
  let transactionData = currentData.todayTransactions.todaysTransactions;

  // find the transaction to modify
  let transactionIndex;
  let transactionToModify = transactionData.find((transaction, i) => {
    if (transaction.transID.toString() === transactionID.toString()) {
      transactionIndex = i;
      return transaction;
    }
  });

  // modify the transaction

  if (transactionToModify) {
    /* let productsToModify = transactionToModify.products.map((product, index) => {
      !product.returned ? (product.productIsNewlyReturned = true) : (product.productIsNewlyReturned = false);
      product.returned = true;
      product.returnedDate = new Date().toISOString();
      transactionToModify.products[index] = product;

      return product;
    });
    transactionToModify.transactionDetails.modified = true;
    transactionToModify.transactionDetails.deliveryStatus = "returned";
    transactionToModify.transactionDetails.totalAmount = 0;
    transactionToModify.transactionDetails.subTotal = 0;
    transactionToModify.transactionDetails.vat = 0;
    transactionToModify.transactionDetails.discount = 0;

    //if loan transaction
    if (transactionToModify.operationType.whichOperation === "loan") {
      transactionToModify.operationType.balance = 0;
      transactionToModify.operationType.clearedAmount = 0;
      transactionToModify.operationType.amountCleared = 0;
      transactionToModify.operationType.intialPayment = 0;
    }

    console.log("transaction modified", transactionToModify);
    // update the transaction in the array
    transactionData[transactionIndex] = transactionToModify;
    currentData.todayTransactions.todaysTransactions = transactionData;
    console.log("transaction updated", currentData);

    //update the store product collection for the returned product

    let storeProductCollection = currentData.storeProductCollection;

    let updatedStoreProductCollection = updateStoreProductCollectionsForAllProductReturned(
      storeProductCollection,
      productsToModify,
      transactionToModify.transactionDetails.date,
      transactionToModify.customer.fullName
    );

    currentData.storeProductCollection = updatedStoreProductCollection;

    await store.put(currentData, objectName);
    await tx.done;

    return { transactionList: currentData.todayTransactions.todaysTransactions, modifiedTransaction: transactionToModify }; */
    transactionToModify = structuredClone(transactionToModify);

    const productsToModify = transactionToModify.products.map((product) => {
      const updatedProduct = { ...product };

      if (!updatedProduct.returned) {
        updatedProduct.productIsNewlyReturned = true;
        updatedProduct.returned = true;
        updatedProduct.returnedDate = new Date().toISOString();
      } else {
        updatedProduct.productIsNewlyReturned = false;
      }

      return updatedProduct;
    });

    transactionToModify.products = productsToModify;

    const newlyReturnedProducts = productsToModify.filter((product) => product.productIsNewlyReturned);

    transactionToModify.transactionDetails.modified = true;
    transactionToModify.transactionDetails.deliveryStatus = "returned";
    transactionToModify.transactionDetails.totalAmount = 0;
    transactionToModify.transactionDetails.subTotal = 0;
    transactionToModify.transactionDetails.vat = 0;
    transactionToModify.transactionDetails.discount = 0;

    if (transactionToModify.operationType.whichOperation === "loan") {
      transactionToModify.operationType.balance = 0;
      transactionToModify.operationType.clearedAmount = 0;
      transactionToModify.operationType.amountCleared = 0;
      transactionToModify.operationType.intialPayment = 0;
    }

    transactionData[transactionIndex] = transactionToModify;
    currentData.todayTransactions.todaysTransactions = transactionData;

    currentData.storeProductCollection = updateStoreProductCollectionsForAllProductReturned(
      currentData.storeProductCollection,
      newlyReturnedProducts,
      transactionToModify.transactionDetails.date,
      transactionToModify.customer.fullName,
    );

    await store.put(currentData, objectName);
    await tx.done;

    return {
      transactionList: currentData.todayTransactions.todaysTransactions,
      modifiedTransaction: transactionToModify,
    };
  } else {
    console.log("transaction not found IDB error");
    throw new Error("transaction not found IDB error");
  }
};

// ✅ return one product as it should be handled in the server

export const returnOneProductInTodayTransaction = async (objectName, transactionID, productID, subUnitID) => {
  try {
    const db = await createIDB(objectName);
    const tx = db.transaction(objectName, "readwrite");
    const store = tx.objectStore(objectName);
    let currentData = await store.get(objectName);
    let transactionData = currentData.todayTransactions.todaysTransactions;

    // find the transaction to modify
    let transactionIndex;
    let transactionToModify = transactionData.find((transaction, i) => {
      console.log(transaction.transID, transactionID);

      if (transaction.transID.toString() === transactionID.toString()) {
        transactionIndex = i;
        return transaction;
      }
    });

    // modify the transaction and product
    if (transactionToModify) {
      let productIndex;
      /* let productToModify = transactionToModify.products.find((product, i) => {
      const sameProduct = String(product.id) === String(productID);
      const sameSubUnit = product.isSubUnitSold ? String(product.subUnitId) === String(subUnitID) : true;
      console.log(sameProduct, sameSubUnit, "same product and subunit check");

      if (sameProduct && sameSubUnit) {
        productIndex = i;
        return true;
      }

      return false;
    }); */
      let productToModify = transactionToModify.products.find((product, i) => {
        const sameProduct = String(product.id) === String(productID);

        if (!sameProduct) return false;

        if (subUnitID) {
          if (!product.isSubUnitSold) return false;

          if (String(product.subUnitId) === String(subUnitID)) {
            productIndex = i;
            return true;
          }

          return false;
        }

        if (!product.isSubUnitSold) {
          productIndex = i;
          return true;
        }

        return false;
      });

      if (!productToModify) {
        throw new Error("product not found IDB error");
      }

      if (productToModify.returned) {
        throw new Error("This item has already been returned");
      }

      if (productToModify) {
        productToModify.returned = true;
        productToModify.returnedDate = new Date().toISOString();
        productToModify.productIsNewlyReturned = true;
        transactionToModify.products[productIndex] = productToModify;
      } else {
        console.log("product not found IDB error");
        throw new Error("product not found IDB error");
      }

      transactionToModify.transactionDetails.modified = true;
      /*  transactionToModify.transactionDetails.totalAmount = Number(transactionToModify.transactionDetails.totalAmount) - Number(productToModify.totalAmount); */

      if (Number(transactionToModify.transactionDetails.vat) > 0) {
        const vatPercentage = getNumber(transactionToModify.transactionDetails.vatPercentage, 0);
        console.log(vatPercentage, "vat percentage in return one product after parsing");

        let vatOfReturnedItem = (vatPercentage / 100) * Number(productToModify.quantity) * Number(productToModify.soldUnitPrice);

        console.log(vatOfReturnedItem, "vat of returned item");

        const totalAmountToReturn = Number(productToModify.quantity) * Number(productToModify.soldUnitPrice) + vatOfReturnedItem;

        //remove it from subTotal and total amount and subtract vat from total vat

        transactionToModify.transactionDetails.subTotal = Math.max(0, Number(transactionToModify.transactionDetails.subTotal || 0) - totalAmountToReturn);
        transactionToModify.transactionDetails.totalAmount = Math.max(0, Number(transactionToModify.transactionDetails.totalAmount || 0) - totalAmountToReturn);
        transactionToModify.transactionDetails.vat = Math.max(0, Number(transactionToModify.transactionDetails.vat || 0) - vatOfReturnedItem);
      } else {
        const totalAmountToReturn = Number(productToModify.quantity) * Number(productToModify.soldUnitPrice);

        transactionToModify.transactionDetails.subTotal = Math.max(0, Number(transactionToModify.transactionDetails.subTotal || 0) - totalAmountToReturn);
        transactionToModify.transactionDetails.totalAmount = Math.max(0, Number(transactionToModify.transactionDetails.totalAmount || 0) - totalAmountToReturn);
      }

      let isAllProductReturned = transactionToModify.products.every((product) => product.returned === true);

      console.log("isAllProductReturned", isAllProductReturned);

      if (isAllProductReturned) {
        transactionToModify.transactionDetails.deliveryStatus = "returned";
        transactionToModify.transactionDetails.totalAmount = 0;
        transactionToModify.transactionDetails.subTotal = 0;
        transactionToModify.transactionDetails.vat = 0;
        transactionToModify.transactionDetails.discount = 0;
      }

      // update the transaction in the array
      transactionData[transactionIndex] = transactionToModify;
      currentData.todayTransactions.todaysTransactions = transactionData;

      //update the store product collection for the returned product
      let storeProductCollection = currentData.storeProductCollection;

      let updatedStoreProductCollection = updateStoreProductCollectionsForOneProductReturned(
        storeProductCollection,
        productID,
        productToModify,
        transactionToModify.transactionDetails.date,
        transactionToModify.customer.fullName,
      );

      currentData.storeProductCollection = updatedStoreProductCollection;

      await store.put(currentData, objectName);
      await tx.done;

      return {
        transactionList: currentData.todayTransactions.todaysTransactions,
        modifiedTransaction: transactionToModify,
        modifiedProduct: productToModify,
        error: null,
      };
    } else {
      console.log("transaction not found IDB error");
      throw new Error("transaction not found IDB error");
    }
  } catch (error) {
    console.log(error, "Error in returnOneProductInTodayTransaction");
    return { transactionList: null, modifiedTransaction: null, modifiedProduct: null, error: error || "An error occurred while processing the return" };
  }
};

//helper
const getNumber = (value, fallback = 0) => {
  if (value == null) return fallback;

  if (typeof value === "object") {
    if (value.$numberDecimal != null) return Number(value.$numberDecimal);
    if (value.$numberInt != null) return Number(value.$numberInt);
    if (value.$numberDouble != null) return Number(value.$numberDouble);
  }

  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
};

// ✅ Supply all product as it should be handled in the server

export const supplyAllProductsInTodayTransaction = async (objectName, transactionID) => {
  const db = await createIDB(objectName);
  const tx = db.transaction(objectName, "readwrite");
  const store = tx.objectStore(objectName);
  let currentData = await store.get(objectName);
  let transactionData = currentData.todayTransactions.todaysTransactions;
  //console.log(transactionData[0].transID, transactionID);

  // find the transaction to modify
  let transactionIndex;
  let transactionToModify = transactionData.find((transaction, i) => {
    // console.log(transaction.transID, transactionID);
    if (transaction.transID.toString() === transactionID.toString()) {
      transactionIndex = i;
      return transaction;
    }
  });

  // modify the transaction

  if (transactionToModify) {
    transactionToModify.products.map((product, index) => {
      product.supplied = true;
      product.suppliedDate = new Date().toISOString();
      transactionToModify.products[index] = product;

      return product;
    });
    transactionToModify.transactionDetails.modified = true;
    transactionToModify.transactionDetails.deliveryStatus = "supplied";

    console.log("transaction modified", transactionToModify);
    // update the transaction in the array
    transactionData[transactionIndex] = transactionToModify;
    currentData.todayTransactions.todaysTransactions = transactionData;
    console.log("transaction updated", currentData);

    await store.put(currentData, objectName);
    await tx.done;

    return { transactionList: currentData.todayTransactions.todaysTransactions, modifiedTransaction: transactionToModify };
  } else {
    console.log("transaction not found IDB error");
    throw new Error("transaction not found IDB error");
  }
};

// ✅ Clear loan data as it should be handled in the server

export const clearLoanData = async (objectName, transactionID, totalClearedAmount, paymentMode, payments, amount) => {
  const db = await createIDB(objectName);
  const tx = db.transaction(objectName, "readwrite");
  const store = tx.objectStore(objectName);
  let currentData = await store.get(objectName);
  let transactionData = currentData.todayTransactions.todaysTransactions;

  // find the transaction to modify
  let transactionIndex;
  let transactionToModify = transactionData.find((transaction, i) => {
    if (transaction.transID.toString() === transactionID.toString()) {
      transactionIndex = i;
      return transaction;
    }
  });

  // modify the transaction

  if (transactionToModify) {
    transactionToModify.operationType.clearedAmount = transactionToModify.operationType.clearedAmount
      ? Number(transactionToModify.operationType.clearedAmount) + Number(totalClearedAmount)
      : parseInt(totalClearedAmount);

    transactionToModify.operationType.balance = 0;
    transactionToModify.operationType.clearedDate = new Date().toDateString();
    transactionToModify.operationType.loanDuration = 0;

    /* update store todays clear laon */
    currentData.todayTransactions.todaysClearedLoan = Number(currentData.todayTransactions.todaysClearedLoan) + Number(totalClearedAmount);

    //update the payments
    if (transactionToModify.transactionDetails.payments && Array.isArray(transactionToModify.transactionDetails.payments)) {
      transactionToModify.transactionDetails.payments = [...(transactionToModify.transactionDetails.payments || []), ...(payments || [])];
    } else {
      transactionToModify.transactionDetails.payments = payments || [];
    }

    updatePaymentDistribution(currentData.todayTransactions.clearloanDistribution, paymentMode, amount, payments);

    /* if (paymentMode === "cash") {
      currentData.todayTransactions.clearloanDistribution.cash = currentData.todayTransactions.clearloanDistribution.cash + Number(totalClearedAmount);
    } else if (paymentMode === "card") {
      currentData.todayTransactions.clearloanDistribution.card = currentData.todayTransactions.clearloanDistribution.card + Number(totalClearedAmount);
    } else {
      currentData.todayTransactions.clearloanDistribution.mobilePay =
        currentData.todayTransactions.clearloanDistribution.mobilePay + Number(totalClearedAmount);
    } */

    console.log("transaction modified", transactionToModify);
    // update the transaction in the array
    transactionData[transactionIndex] = transactionToModify;
    currentData.todayTransactions.todaysTransactions = transactionData;
    console.log("transaction updated", currentData);

    await store.put(currentData, objectName);
    await tx.done;

    return {
      transactionList: currentData.todayTransactions.todaysTransactions,
      modifiedTransaction: transactionToModify,
      clearedLoanToday: currentData.todayTransactions.todaysClearedLoan,
    };
  } else {
    console.log("transaction not found IDB error");
    throw new Error("transaction not found IDB error");
  }
};

// ✅ Split loan payment as it should be handled in the server

export const splitLoanPayment = async (objectName, transactionID, amountCleared, paymentMode, payment, splitPaymentAmount) => {
  const db = await createIDB(objectName);
  const tx = db.transaction(objectName, "readwrite");
  const store = tx.objectStore(objectName);
  let currentData = await store.get(objectName);
  let transactionData = currentData.todayTransactions.todaysTransactions;

  // find the transaction to modify
  let transactionIndex;
  let transactionToModify = transactionData.find((transaction, i) => {
    if (transaction.transID.toString() === transactionID.toString()) {
      transactionIndex = i;
      return transaction;
    }
  });

  // modify the transaction

  if (transactionToModify) {
    transactionToModify.operationType.clearedAmount = transactionToModify.operationType.clearedAmount
      ? Number(transactionToModify.operationType.clearedAmount) + Number(amountCleared)
      : Number(amountCleared);

    transactionToModify.operationType.balance = Number(transactionToModify.operationType.balance) - Number(amountCleared);
    transactionToModify.operationType.clearedDate = transactionToModify.operationType.balance === 0 ? new Date().toISOString().split("T")[0] : null;

    //update the payments
    if (transactionToModify.transactionDetails.payments && Array.isArray(transactionToModify.transactionDetails.payments)) {
      transactionToModify.transactionDetails.payments = [...(transactionToModify.transactionDetails.payments || []), ...(payment || [])];
    } else {
      transactionToModify.transactionDetails.payments = payment || [];
    }

    /* update store todays clear laon */
    currentData.todayTransactions.todaysClearedLoan = Number(currentData.todayTransactions.todaysClearedLoan) + Number(amountCleared);

    console.log(currentData.todayTransactions.clearloanDistribution, currentData, "currentData check");

    updatePaymentDistribution(currentData.todayTransactions.clearloanDistribution, paymentMode, amountCleared, payment);

    /*   if (paymentMode === "cash") {
      currentData.todayTransactions.clearloanDistribution.cash = currentData.todayTransactions.clearloanDistribution.cash + Number(amountCleared);
    } else if (paymentMode === "card") {
      currentData.todayTransactions.clearloanDistribution.card = currentData.todayTransactions.clearloanDistribution.card + Number(amountCleared);
    } else {
      currentData.todayTransactions.clearloanDistribution.mobilePay = currentData.todayTransactions.clearloanDistribution.mobilePay + Number(amountCleared);
    } */

    console.log("transaction modified", transactionToModify);
    // update the transaction in the array
    transactionData[transactionIndex] = transactionToModify;
    currentData.todayTransactions.todaysTransactions = transactionData;
    console.log("transaction updated", currentData);

    await store.put(currentData, objectName);
    await tx.done;

    return {
      transactionList: currentData.todayTransactions.todaysTransactions,
      modifiedTransaction: transactionToModify,
      clearedLoanToday: currentData.todayTransactions.todaysClearedLoan,
    };
  } else {
    console.log("transaction not found IDB error");
    throw new Error("transaction not found IDB error");
  }
};

// ✅ Extend loan duration as it should be handled in the server

export const extendLoanDuration = async (objectName, transactionID, newDate) => {
  console.log("transactionID", transactionID, newDate);

  const db = await createIDB(objectName);
  const tx = db.transaction(objectName, "readwrite");
  const store = tx.objectStore(objectName);
  let currentData = await store.get(objectName);
  let transactionData = currentData.todayTransactions.todaysTransactions;

  // find the transaction to modify
  let transactionIndex;
  let transactionToModify = transactionData.find((transaction, i) => {
    if (transaction.transID.toString() === transactionID.toString()) {
      transactionIndex = i;
      return transaction;
    }
  });

  // modify the transaction

  if (transactionToModify) {
    transactionToModify.operationType.loanDuration =
      new Date(newDate).getTime() - new Date(transactionToModify.operationType.dateToPay).getTime() + transactionToModify.operationType.loanDuration;
    transactionToModify.operationType.dateToPay = newDate;

    console.log(
      "transaction modified",
      new Date(newDate).getTime() - new Date(transactionToModify.operationType.dateToPay).getTime(),
      transactionToModify.operationType.loanDuration,
      transactionToModify.operationType.dateToPay,
      new Date(newDate).getTime() - new Date(transactionToModify.operationType.dateToPay).getTime() + transactionToModify.operationType.loanDuration,
    );
    // update the transaction in the array
    transactionData[transactionIndex] = transactionToModify;
    currentData.todayTransactions.todaysTransactions = transactionData;
    console.log("transaction updated", currentData);

    await store.put(currentData, objectName);
    await tx.done;

    return { transactionList: currentData.todayTransactions.todaysTransactions, modifiedTransaction: transactionToModify };
  } else {
    console.log("transaction not found IDB error");
    throw new Error("transaction not found IDB error");
  }
};

// ✅ Delete Database

export const deleteDB = async () => {
  try {
    // 1  broadcast “close”
    const bc = new BroadcastChannel("storelense-idb");
    bc.postMessage("close-idb");
    bc.close();

    // 2  also tell the Service-Worker (if you have one)
    if (navigator.serviceWorker?.controller) {
      navigator.serviceWorker.controller.postMessage({ type: "CLOSE_IDB" });
    }

    // 3  give everyone a moment to respond
    await new Promise((r) => setTimeout(r, 300));

    // 4  now try the delete
    const req = indexedDB.deleteDatabase("StorelenseOfflineDB");
    req.onsuccess = () => console.log("✅ DB deleted");
    req.onerror = (e) => console.error("❌ Delete failed:", e.target.error);
    req.onblocked = () => console.warn("⚠️ Still blocked — a tab or SW is holding it open");
  } catch (error) {
    console.error(error, "Error deleting database");
  }
};

/* const updateStoreProductCollectionsFunc = (currentData, data) => {
  let UpdatedStoreProductCollection = currentData.storeProductCollection.map((product) => {
   

    const soldProducts = data.products.filter((prod) => prod.id.toString() === product._id.toString());

    if (!soldProducts.length) return product;

    for (const soldProduct of soldProducts) {
      let soldProductEquivalentInProductUnits = soldProduct.quantity;

      if (soldProduct.isSubUnitSold) {
       
        const baseUnitsSold = processSubUnitSale(product, soldProduct);

        soldProductEquivalentInProductUnits = baseUnitsSold;
       
        let i;
        let matchedHistory = product.history.find((hist, index) => {
          if (JSON.stringify(hist.date).split("T")[0] === JSON.stringify(new Date()).split("T")[0]) {
            let i_;
            let matchedActivity;
            hist.activity.find((act, index_) => {
              if (act.includes("Sold") && act.includes(soldProduct.unit) && act.includes("sub-unit")) {
                let currentSoldItem = Number(act.split(" ")[1]);
                act = `Sold ${Number(currentSoldItem) + Number(soldProduct.quantity)} ${soldProduct.unit} of ${product.name} (sub-unit)`;

                i_ = index_;
                return (matchedActivity = act);
              }
            });
            if (matchedActivity) {
              hist.activity[i_] = matchedActivity;
            } else {
              hist.activity = [...hist.activity, `Sold ${soldProduct.quantity} ${soldProduct.unit} of ${product.name} (sub-unit)`];
            }
            i = index;
            return hist;
          }
        });

        if (matchedHistory) {
          product.history[i] = matchedHistory;
        } else {
          product.history = [
            ...product.history,
            { date: new Date(), activity: [`Sold ${soldProduct.quantity} ${soldProduct.unit} of ${product.name} (sub-unit)`] },
          ];
        }
      } else {
        
        let i;
        let matchedHistory = product.history.find((hist, index) => {
          if (JSON.stringify(hist.date).split("T")[0] === JSON.stringify(new Date()).split("T")[0]) {
            let i_;
            let matchedActivity;
            hist.activity.find((act, index_) => {
              if (act.includes("Sold") && act.includes(soldProduct.unit) && !act.includes("sub-unit")) {
                let currentSoldItem = Number(act.split(" ")[1]);
                act = `Sold ${Number(currentSoldItem) + Number(soldProduct.quantity)} ${soldProduct.unit} of ${product.name}`;

                i_ = index_;
                return (matchedActivity = act);
              }
            });
            if (matchedActivity) {
              hist.activity[i_] = matchedActivity;
            } else {
              hist.activity = [...hist.activity, `Sold ${soldProduct.quantity} ${soldProduct.unit} of ${product.name}`];
            }
            i = index;
            return hist;
          }
        });

        if (matchedHistory) {
          product.history[i] = matchedHistory;
        } else {
          product.history = [...product.history, { date: new Date(), activity: [`Sold ${soldProduct.quantity} ${soldProduct.unit} of ${product.name}`] }];
        }
      }

      product.soldAmountToday = product.soldAmountToday
        ? Number(product.soldAmountToday) + Number(soldProductEquivalentInProductUnits)
        : soldProductEquivalentInProductUnits;
      product.quantity = Number(product.quantity) - Number(soldProductEquivalentInProductUnits);
      product.totalWorth = Number(product.quantity) * Number(product.costPrice);

      product.soldAmountAllTime = product.soldAmountAllTime
        ? Number(product.soldAmountAllTime) + Number(soldProductEquivalentInProductUnits)
        : soldProductEquivalentInProductUnits;
      // update all Sales Offline
      // get the current year and month
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth(); // 0-indexed, so January is 0

      // find the allSalesOffline entry for the current year
      let allSalesOfflineEntryCurrentYear = product.allSalesOffline.find((entry) => entry.year === currentYear);

      if (allSalesOfflineEntryCurrentYear) {
        // entry exists find the curent month and update the sales
        let salesByMonth = allSalesOfflineEntryCurrentYear.salesByMonth.find((sales) => sales.month === currentMonth);
        //if current month exists then update the sales
        if (salesByMonth) {
          salesByMonth.salesPrice = Number(salesByMonth.salesPrice) + Number(soldProduct.soldUnitPrice) * Number(soldProductEquivalentInProductUnits);
          salesByMonth.quantity = Number(salesByMonth.quantity) + Number(soldProductEquivalentInProductUnits);
        } else {
          // if current month does not exist then create a new month entry
          allSalesOfflineEntryCurrentYear.salesByMonth = [
            ...allSalesOfflineEntryCurrentYear.salesByMonth,
            {
              month: currentMonth,
              salesPrice: Number(soldProduct.soldUnitPrice) * Number(soldProductEquivalentInProductUnits),
              quantity: soldProductEquivalentInProductUnits,
            },
          ];
        }
      } else {
        // new year then create new template
        let newSalesByMonth = Array.from({ length: 12 }, (_, i) => ({ month: i, salesPrice: 0, quantity: 0 }));

        newSalesByMonth[currentMonth] = {
          month: currentMonth,
          salesPrice: Number(soldProduct.soldUnitPrice) * Number(soldProductEquivalentInProductUnits),
          quantity: soldProductEquivalentInProductUnits,
        };

        product.allSalesOffline.push({ year: currentYear, salesByMonth: newSalesByMonth });
      }

    
    }
    return product;
  });


  let productsAppraochingStockLimit = UpdatedStoreProductCollection.filter((product) => product.quantity <= product.stockLimit);

  console.log(`Products appraoching stock limit`, productsAppraochingStockLimit, UpdatedStoreProductCollection);

  let productsAppraochingStockLimitNames;
  let shouldSendNotification;
  if (productsAppraochingStockLimit.length > 0) {
    productsAppraochingStockLimitNames = productsAppraochingStockLimit.map((product) => product.name);
    console.log(`Products appraoching stock limit ${productsAppraochingStockLimitNames}`);
    shouldSendNotification = true;
  } else {
    productsAppraochingStockLimitNames = [];
    shouldSendNotification = false;
  }

  return { UpdatedStoreProductCollection, productsAppraochingStockLimitNames, shouldSendNotification };
}; */

const updateStoreProductCollectionsFunc = (currentData, data) => {
  const productsSold = [];
  const UpdatedStoreProductCollection = currentData.storeProductCollection.map((product) => {
    const updatedProduct = structuredClone(product);

    const soldProducts = data.products.filter((prod) => String(prod.id) === String(updatedProduct._id));

    if (!soldProducts.length) return updatedProduct;
    console.log(updatedProduct, soldProducts, "sold products for this item");

    for (const soldProduct of soldProducts) {
      let soldProductEquivalentInProductUnits = Number(soldProduct.quantity || 0);

      let stockUnitsToRemove = Number(soldProduct.quantity || 0);
      let salesUnitsToRecord = Number(soldProduct.quantity || 0);

      if (soldProduct.isSubUnitSold) {
        const baseUnitsUsed = processSubUnitSale(updatedProduct, soldProduct);
        soldProductEquivalentInProductUnits = baseUnitsUsed;

        const subUnit = updatedProduct.subUnits.find((su) => String(su.id) === String(soldProduct.subUnitId));

        stockUnitsToRemove = baseUnitsUsed;

        salesUnitsToRecord = Math.ceil(Number(soldProduct.quantity || 0) / Number(subUnit.conversionFactor || 1));

        updateProductSoldHistory(updatedProduct, soldProduct, true);
      } else {
        updateProductSoldHistory(updatedProduct, soldProduct, false);
      }

      if (Number(updatedProduct.quantity || 0) < stockUnitsToRemove) {
        throw new Error(`Not enough stock for ${updatedProduct.name}. A minimum of ${stockUnitsToRemove} is required.`);
      }
      updatedProduct.quantity = Number(updatedProduct.quantity || 0) - stockUnitsToRemove;

      updatedProduct.soldAmountToday = Number(updatedProduct.soldAmountToday || 0) + salesUnitsToRecord;

      updatedProduct.totalWorth = Number(updatedProduct.quantity || 0) * Number(updatedProduct.costPrice || 0);

      updatedProduct.soldAmountAllTime = Number(updatedProduct.soldAmountAllTime || 0) + salesUnitsToRecord;

      updateAllSalesOffline(updatedProduct, soldProduct, salesUnitsToRecord);
      productsSold.push({ ...soldProduct, name: updatedProduct.name, stockLimit: updatedProduct.stockLimit, quantityInStock: updatedProduct.quantity });
    }

    return updatedProduct;
  });

  const productsAppraochingStockLimit = productsSold.filter((product) => Number(product.quantityInStock || 0) <= Number(product.stockLimit || 0));

  return {
    UpdatedStoreProductCollection,
    productsAppraochingStockLimitNames: productsAppraochingStockLimit.map((product) => product.name),
    shouldSendNotification: productsAppraochingStockLimit.length > 0,
  };
};

/* const updateStoreProductCollectionsForOneProductReturned = (storeProductCollection, productID, productToModify, dateSold, customerName) => {
  let updatedStoreProductCollection = storeProductCollection.map((product) => {
    if (product._id.toString() === productID.toString()) {
      product.quantity = Number(product.quantity) + Number(productToModify.quantity);
      product.totalWorth = Number(product.quantity) * Number(product.costPrice);

      product.soldAmountToday = Number(product.soldAmountToday) - Number(productToModify.quantity);

      product.soldAmountAllTime = Number(product.soldAmountAllTime) - Number(productToModify.quantity);

      // update history
      product.history = updateProductHistory(product.history, `Returned ${productToModify.quantity} of ${product.name} by ${customerName}.`);

      // update all Sales Offline

      let monthItemWasSold = new Date(dateSold).getMonth(); // 0-indexed, so January is 0
      let yearItemWasSold = new Date(dateSold).getFullYear();

      // find the allSalesOffline entry for the year and month item was sold

      let allSalesOfflineEntry = product.allSalesOffline.find((entry) => entry.year === yearItemWasSold);

      if (allSalesOfflineEntry) {
        // entry exists find the month and update the sales
        let salesByMonth = allSalesOfflineEntry.salesByMonth.find((sales) => sales.month === monthItemWasSold);
        //if month exists then update the sales
        if (salesByMonth) {
          salesByMonth.salesPrice = Number(salesByMonth.salesPrice) - Number(productToModify.soldUnitPrice) * Number(productToModify.quantity);
          salesByMonth.quantity = Number(salesByMonth.quantity) - Number(productToModify.quantity);
        }
      }
    }
    return product;
  });
  return updatedStoreProductCollection;
}; */

const updateStoreProductCollectionsForOneProductReturned = (storeProductCollection, productID, productToModify, dateSold, customerName) => {
  return storeProductCollection.map((product) => {
    if (String(product._id) !== String(productID)) {
      return product;
    }

    const updatedProduct = structuredClone(product);

    let quantityToRemoveFromSales = Number(productToModify.quantity || 0);
    const salesPriceToRemove = Number(productToModify.soldUnitPrice || 0) * Number(productToModify.quantity || 0);

    if (productToModify.isSubUnitSold) {
      updatedProduct.subUnits = updatedProduct.subUnits?.map((subUnit) => {
        if (String(subUnit.id) === String(productToModify.subUnitId)) {
          const conversionFactor = Number(subUnit.conversionFactor || 1);

          subUnit.quantityOfSubUnitInStock = Number(subUnit.quantityOfSubUnitInStock || 0) + Number(productToModify.quantity || 0);

          quantityToRemoveFromSales = Math.ceil(Number(productToModify.quantity || 0) / conversionFactor);
        }

        return subUnit;
      });
    } else {
      updatedProduct.quantity = Number(updatedProduct.quantity || 0) + Number(productToModify.quantity || 0);
    }

    updatedProduct.totalWorth = Number(updatedProduct.quantity || 0) * Number(updatedProduct.costPrice || 0);

    updatedProduct.soldAmountToday = Math.max(0, Number(updatedProduct.soldAmountToday || 0) - quantityToRemoveFromSales);

    updatedProduct.soldAmountAllTime = Math.max(0, Number(updatedProduct.soldAmountAllTime || 0) - quantityToRemoveFromSales);

    updatedProduct.history = updateProductHistory(
      updatedProduct.history,
      `Returned ${productToModify.quantity} ${productToModify.unit || ""} of ${updatedProduct.name} by ${customerName}.`,
    );

    const monthItemWasSold = new Date(dateSold).getMonth();
    const yearItemWasSold = new Date(dateSold).getFullYear();

    const yearEntry = updatedProduct.allSalesOffline?.find((entry) => Number(entry.year) === yearItemWasSold);

    if (yearEntry) {
      const salesByMonth = yearEntry.salesByMonth?.find((sales) => Number(sales.month) === monthItemWasSold);

      if (salesByMonth) {
        salesByMonth.salesPrice = Math.max(0, Number(salesByMonth.salesPrice || 0) - salesPriceToRemove);

        salesByMonth.quantity = Math.max(0, Number(salesByMonth.quantity || 0) - quantityToRemoveFromSales);
      }
    }

    return updatedProduct;
  });
};
// ✅ Update store product collection for all product returned
/* const updateStoreProductCollectionsForAllProductReturned = (storeProductCollection, productsToModify, transactionDate, customerName) => {
  //products to modify is an array of products that are returned
  let updatedStoreProductCollection = storeProductCollection.map((product) => {
    let returnedProduct = productsToModify.find((returnedProduct) => returnedProduct.id === product._id);

    if (returnedProduct) {
      product.quantity = Number(product.quantity) + Number(returnedProduct.quantity);
      product.totalWorth = parseInt(product.quantity, 10) * parseInt(product.costPrice, 10);

      product.soldAmountToday = Number(product.soldAmountToday) - Number(returnedProduct.quantity);

      product.soldAmountAllTime = Number(product.soldAmountAllTime) - Number(returnedProduct.quantity);

      // update history
      product.history = updateProductHistory(product.history, `Returned ${returnedProduct.quantity} of ${product.name} by ${customerName}.`);

      // update all Sales Offline

      let monthItemWasSold = new Date(transactionDate).getMonth(); // 0-indexed, so January is 0
      let yearItemWasSold = new Date(transactionDate).getFullYear();

      // find the allSalesOffline entry for the year and month item was sold

      let allSalesOfflineEntry = product.allSalesOffline.find((entry) => entry.year === yearItemWasSold);

      if (allSalesOfflineEntry) {
        // entry exists find the month and update the sales
        let salesByMonth = allSalesOfflineEntry.salesByMonth.find((sales) => sales.month === monthItemWasSold);
        //if month exists then update the sales
        if (salesByMonth) {
          salesByMonth.salesPrice =
            parseInt(salesByMonth.salesPrice, 10) - parseInt(returnedProduct.soldUnitPrice, 10) * parseInt(returnedProduct.quantity, 10);
          salesByMonth.quantity = Number(salesByMonth.quantity) - Number(returnedProduct.quantity);
        }
      }
    }
    return product;
  });
  return updatedStoreProductCollection;
}; */

const updateStoreProductCollectionsForAllProductReturned = (storeProductCollection, productsToModify, transactionDate, customerName) => {
  return storeProductCollection.map((product) => {
    const returnedProducts = productsToModify.filter((returnedProduct) => String(returnedProduct.id) === String(product._id));

    if (!returnedProducts.length) return product;

    const updatedProduct = structuredClone(product);

    for (const returnedProduct of returnedProducts) {
      let quantityToRemoveFromSales = Number(returnedProduct.quantity || 0);

      const salesPriceToRemove = Number(returnedProduct.soldUnitPrice || 0) * Number(returnedProduct.quantity || 0);

      if (returnedProduct.isSubUnitSold) {
        updatedProduct.subUnits = updatedProduct.subUnits?.map((subUnit) => {
          if (String(subUnit.id) === String(returnedProduct.subUnitId)) {
            const conversionFactor = Number(subUnit.conversionFactor || 1);

            subUnit.quantityOfSubUnitInStock = Number(subUnit.quantityOfSubUnitInStock || 0) + Number(returnedProduct.quantity || 0);

            quantityToRemoveFromSales = Math.ceil(Number(returnedProduct.quantity || 0) / conversionFactor);
          }

          return subUnit;
        });
      } else {
        updatedProduct.quantity = Number(updatedProduct.quantity || 0) + Number(returnedProduct.quantity || 0);
      }

      updatedProduct.totalWorth = Number(updatedProduct.quantity || 0) * Number(updatedProduct.costPrice || 0);

      updatedProduct.soldAmountToday = Math.max(0, Number(updatedProduct.soldAmountToday || 0) - quantityToRemoveFromSales);

      updatedProduct.soldAmountAllTime = Math.max(0, Number(updatedProduct.soldAmountAllTime || 0) - quantityToRemoveFromSales);

      updatedProduct.history = updateProductHistory(
        updatedProduct.history,
        `Returned ${returnedProduct.quantity} ${returnedProduct.unit || ""} of ${updatedProduct.name} by ${customerName}.`,
      );

      const monthItemWasSold = new Date(transactionDate).getMonth();
      const yearItemWasSold = new Date(transactionDate).getFullYear();

      const allSalesOfflineEntry = updatedProduct.allSalesOffline?.find((entry) => Number(entry.year) === yearItemWasSold);

      if (allSalesOfflineEntry) {
        const salesByMonth = allSalesOfflineEntry.salesByMonth?.find((sales) => Number(sales.month) === monthItemWasSold);

        if (salesByMonth) {
          salesByMonth.salesPrice = Math.max(0, Number(salesByMonth.salesPrice || 0) - salesPriceToRemove);

          salesByMonth.quantity = Math.max(0, Number(salesByMonth.quantity || 0) - quantityToRemoveFromSales);
        }
      }
    }

    return updatedProduct;
  });
};

// ✅ Update product history
// consider converting date of now to TZ adjusted date
const updateProductHistory = (history, payload) => {
  let i;
  let matchedHistory = history.find((history_, index) => {
    if (JSON.stringify(history_.date).split("T")[0] === JSON.stringify(new Date()).split("T")[0]) {
      history_.activity = [...history_.activity, payload];
      i = index;
      return history_;
    }
  });
  if (matchedHistory) {
    history[i] = matchedHistory;
    return history;
  } else {
    history = [...history, { date: new Date(), activity: [payload] }];
    return history;
  }
};

/* function processSubUnitSale(product, soldProduct) {
  const { subUnitId, quantity } = soldProduct;

  const subUnit = product.subUnits.find((su) => String(su.id) === String(subUnitId));

  if (!subUnit) {
    throw new Error("Subunit not found");
  }

  // If not enough subunit stock, convert product units
  const quantitySold = Number(quantity || 0);
  const currentSubUnitStock = Number(subUnit.quantityOfSubUnitInStock || 0);
  const conversionFactor = Number(subUnit.conversionFactor || 1);

  if (quantitySold > currentSubUnitStock) {
    const deficit = Number(quantity) - Number(subUnit.quantityOfSubUnitInStock);

    const baseUnitsNeeded = Math.ceil(deficit / subUnit.conversionFactor);

    subUnit.quantityOfSubUnitInStock = currentSubUnitStock + baseUnitsNeeded * conversionFactor;
  }

  // remove sold quantity
  subUnit.quantityOfSubUnitInStock = Number(subUnit.quantityOfSubUnitInStock || 0) - quantitySold;
  return Math.ceil(quantitySold / conversionFactor);
} */

function processSubUnitSale(product, soldProduct) {
  const subUnit = product.subUnits?.find((su) => String(su.id) === String(soldProduct.subUnitId));

  if (!subUnit) {
    throw new Error(`Subunit not found for ${product.name}`);
  }

  const quantitySold = Number(soldProduct.quantity || 0);
  const currentSubUnitStock = Number(subUnit.quantityOfSubUnitInStock || 0);
  const conversionFactor = Number(subUnit.conversionFactor || 1);

  let baseUnitsUsed = 0;

  if (quantitySold > currentSubUnitStock) {
    const deficit = quantitySold - currentSubUnitStock;
    baseUnitsUsed = Math.ceil(deficit / conversionFactor);

    subUnit.quantityOfSubUnitInStock = currentSubUnitStock + baseUnitsUsed * conversionFactor;
  }

  subUnit.quantityOfSubUnitInStock = Number(subUnit.quantityOfSubUnitInStock || 0) - quantitySold;

  return baseUnitsUsed;
}

function updateProductSoldHistory(product, soldProduct, isSubUnit) {
  const today = new Date().toISOString().split("T")[0];
  const suffix = isSubUnit ? " (sub-unit)" : "";

  let matchedHistory = product.history?.find((hist) => new Date(hist.date).toISOString().split("T")[0] === today);

  const text = `Sold ${soldProduct.quantity} ${soldProduct.unit} of ${product.name}${suffix}`;

  if (!matchedHistory) {
    product.history = [...(product.history || []), { date: new Date(), activity: [text] }];
    return;
  }

  const index = matchedHistory.activity.findIndex((act) =>
    isSubUnit
      ? act.includes("Sold") && act.includes(soldProduct.unit) && act.includes("sub-unit")
      : act.includes("Sold") && act.includes(soldProduct.unit) && !act.includes("sub-unit"),
  );

  if (index >= 0) {
    const currentSoldItem = Number(matchedHistory.activity[index].split(" ")[1]);
    matchedHistory.activity[index] = `Sold ${currentSoldItem + Number(soldProduct.quantity)} ${soldProduct.unit} of ${product.name}${suffix}`;
  } else {
    matchedHistory.activity.push(text);
  }
}

function updateAllSalesOffline(product, soldProduct, productUnitsSold) {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  product.allSalesOffline ||= [];

  let yearEntry = product.allSalesOffline.find((entry) => Number(entry.year) === currentYear);

  if (!yearEntry) {
    yearEntry = {
      year: currentYear,
      salesByMonth: Array.from({ length: 12 }, (_, month) => ({
        month,
        salesPrice: 0,
        quantity: 0,
      })),
    };

    product.allSalesOffline.push(yearEntry);
  }

  let monthEntry = yearEntry.salesByMonth.find((sales) => Number(sales.month) === currentMonth);

  if (!monthEntry) {
    monthEntry = {
      month: currentMonth,
      salesPrice: 0,
      quantity: 0,
    };

    yearEntry.salesByMonth.push(monthEntry);
  }

  monthEntry.salesPrice = Number(monthEntry.salesPrice || 0) + Number(soldProduct.soldUnitPrice || 0) * Number(soldProduct.quantity || 0);

  monthEntry.quantity = Number(monthEntry.quantity || 0) + Number(productUnitsSold || 0);
}

export const updatePaymentDistribution = (distribution, paymentMode, amount, payments = []) => {
  const add = (type, value) => {
    type = type || "cash";

    if (!(type in distribution)) {
      type = "cash";
    }

    distribution[type] += Number(value);
  };

  if (paymentMode === "split") {
    payments.forEach(({ paymentType, amount }) => add(paymentType, amount));
  } else {
    add(paymentMode, amount);
  }
};
